module.exports = __webpack_public_path__ + "static/media/aboutus_m@3x.ff0c23ec.jpg";